import { codepointsToUnicode, parseEmojiPlaceholders } from './placeholder';
import { getEmojiPack } from './emojiSets';

type EmojiTextProps = {
  text: string;
  className?: string;
};

export function EmojiText({ text, className }: EmojiTextProps) {
  const segments = parseEmojiPlaceholders(text);

  return (
    <span className={className ?? 'emoji-text'}>
      {segments.map((segment, index) => {
        if (segment.type === 'text') {
          return <span key={`text-${index}`}>{segment.value}</span>;
        }

        const pack = getEmojiPack(segment.pack);
        const url = pack.resolveUrl(segment.codepoints);
        if (!url) {
          return <span key={`emoji-${index}`}>{segment.raw}</span>;
        }

        return (
          <img
            key={`emoji-${index}`}
            style={{ display: 'inline-block', verticalAlign: '-0.22em', width: '1.1em', height: '1.1em' }}
            src={url}
            alt={codepointsToUnicode(segment.codepoints)}
            loading="lazy"
          />
        );
      })}
    </span>
  );
}
